import en from './en';
import fr from './fr';
import es from './es';
import de from './de';
import ar from './ar';
import zh from './zh';

export const locales = { en, fr, es, de, ar, zh };

export const LANGUAGES = [
  { code: 'en', name: 'English', flag: 'US', dir: 'ltr' },
  { code: 'fr', name: 'Francais', flag: 'FR', dir: 'ltr' },
  { code: 'es', name: 'Espanol', flag: 'ES', dir: 'ltr' },
  { code: 'de', name: 'Deutsch', flag: 'DE', dir: 'ltr' },
  { code: 'ar', name: 'العربية', flag: 'SA', dir: 'rtl' },
  { code: 'zh', name: '中文', flag: 'CN', dir: 'ltr' },
  // Extensible - add more languages by creating locale files
  { code: 'pt', name: 'Portugues', flag: 'BR', dir: 'ltr' },
  { code: 'it', name: 'Italiano', flag: 'IT', dir: 'ltr' },
  { code: 'ja', name: '日本語', flag: 'JP', dir: 'ltr' },
  { code: 'ko', name: '한국어', flag: 'KR', dir: 'ltr' },
  { code: 'ru', name: 'Русский', flag: 'RU', dir: 'ltr' },
  { code: 'hi', name: 'हिन्दी', flag: 'IN', dir: 'ltr' },
  { code: 'tr', name: 'Turkce', flag: 'TR', dir: 'ltr' },
  { code: 'nl', name: 'Nederlands', flag: 'NL', dir: 'ltr' },
  { code: 'pl', name: 'Polski', flag: 'PL', dir: 'ltr' },
  { code: 'sv', name: 'Svenska', flag: 'SE', dir: 'ltr' },
  { code: 'th', name: 'ไทย', flag: 'TH', dir: 'ltr' },
  { code: 'vi', name: 'Tieng Viet', flag: 'VN', dir: 'ltr' },
  { code: 'id', name: 'Bahasa Indonesia', flag: 'ID', dir: 'ltr' },
  { code: 'ms', name: 'Bahasa Melayu', flag: 'MY', dir: 'ltr' },
];

// Languages with full translations
export const SUPPORTED_LOCALES = ['en', 'fr', 'es', 'de', 'ar', 'zh'];

export function getLocale(code) {
  return locales[code] || locales.en;
}

export function detectBrowserLanguage() {
  const browserLang = navigator.language?.split('-')[0] || 'en';
  return SUPPORTED_LOCALES.includes(browserLang) ? browserLang : 'en';
}
